<template>
  <div v-if="banner">
    <div class="banners" :style="{'background': banner.banner_background_color}" :class="{ 'banner-in-partner-page' : isPartnerPages }">
      <div class="flex center-md center-xs">
        <img v-if="banner.banner_icon" :src="s3Path(banner.banner_icon)" alt="Banner" width="24" height="24" loading="lazy" fetchpriority="auto">
        <span :style="{'color': banner.banner_text_color}" class="text-banner">{{ banner.banner_content }}</span>
      </div>
    </div>
  </div>
</template>

<script async>
import { mapGetters } from 'vuex';
import {s3Path} from '@vue-storefront/core/helpers';

export default {
  name: 'ActiveBanners',
  props: {
    banner: {
      type: Object,
      required: true
    }
  },
  computed: {
    isPartnerPages () {
      if (this.currentPartner) {
        let url = '/' + this.currentPartner.location_code + '/' + this.currentPartner.code
        return this.$route.path === url
      }
      return false
    },
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    })
  },
  methods: {
    s3Path
  }
}
</script>

<style scoped>
  .banners {
    background: #ff6033;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.1px;
    text-align: center;
    color: #ffff;
    padding: 4px 8px;
  }
  .text-banner {
    margin-left: 5px;
    align-self: center;
  }
</style>
